import { Checkbox, FormControlLabel, Grid, Typography } from "@mui/material";
import { Resources, useResource } from "Translations/Resources";

const RESOURCES = Resources.Components.Shared.Filters;

type Props = {
  value: boolean;
  onChange: (value: boolean) => void;
};

export const RefundOrCancellationFilter = ({ value, onChange }: Props) => {
  const { t } = useResource();

  return (
    <Grid size={{ xs: 12, sm: 6 }}>
      <Typography fontSize={13} fontWeight={400} mb={1}>
        {t(RESOURCES.RefundOrCancellation)}
      </Typography>
      <FormControlLabel
        control={
          <Checkbox
            checked={value}
            onChange={(e) => onChange(e.target.checked)}
            sx={{
              color: "text.secondary",
              "&.Mui-checked": {
                color: "primary.main",
              },
            }}
          />
        }
        label={
          <Typography fontSize={14} color="text.primary">
            {t(RESOURCES.ShowOnlyRefundsAndCancellations)}
          </Typography>
        }
        sx={{ m: 0 }}
      />
    </Grid>
  );
};
